import React from "react";
import { Box, Grid } from "@mui/material";
interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string
}

const SkillsNote: React.FC<{ data: group[] }> = ({ data }) => {
    const skills = data.map(item => item.groupTitle);
    return (
        <>
            <div className="skill-item-div">
                <Grid container spacing={2}>
                    <Grid item xs={6} mt={2}>
                        {skills.slice(0, 5).map((skill, index) => (
                            <Box className="skill-item circle-number-parent" key={index} mb={1}><span dangerouslySetInnerHTML={{ __html: skill || '' }}/></Box>
                        ))}
                    </Grid>

                    <Grid item xs={6} mt={2}>
                        {skills.slice(5).map((skill, index) => (
                            <Box className="skill-item circle-number-parent" key={index} mb={1}><span dangerouslySetInnerHTML={{ __html: skill || '' }}/></Box>
                        ))}
                    </Grid>
                </Grid>

                <Box display="flex" alignItems="center" mt={3}>
                    <Box className="line-description-chart deviation" />
                    <Box className="skill-item" ml={1}>あなたの偏差値</Box>
                    <Box className="line-description-chart standard-deviation" ml={4}/>
                    <Box className="skill-item" ml={1}>偏差値</Box>
                </Box>
            </div>
        </>
    );
}
export default SkillsNote;
